import { createAction } from '@reduxjs/toolkit';

export const GET_ENRICHED_SCHEMAS = 'GET_ENRICHED_SCHEMAS';
export const GET_PAGINATED_ENRICHED_SCHEMAS = 'GET_PAGINATED_ENRICHED_SCHEMAS';
export const GETTING_ENRICHED_SCHEMAS_SUCCEEDED =
  'GETTING_ENRICHED_SCHEMAS_SUCCEEDED';
export const GETTING_PAGINATED_ENRICHED_SCHEMAS_SUCCEEDED =
  'GETTING_PAGINATED_ENRICHED_SCHEMAS_SUCCEEDED';
export const GETTING_ENRICHED_SCHEMAS_FAILED =
  'GETTING_ENRICHED_SCHEMAS_FAILED';
export const GETTING_PAGINATED_ENRICHED_SCHEMAS_FAILED =
  'GETTING_PAGINATED_ENRICHED_SCHEMAS_FAILED';

export const GET_ENRICHED_SCHEMA = 'GET_ENRICHED_SCHEMA';
export const GETTING_ENRICHED_SCHEMA_FAILED = 'GETTING_ENRICHED_SCHEMA_FAILED';
export const GETTING_ENRICHED_SCHEMA_SUCCEEDED =
  'GETTING_ENRICHED_SCHEMA_SUCCEEDED';

export const GET_ENRICHED_SCHEMA_KEYS = 'GET_ENRICHED_SCHEMA_KEYS';
export const GETTING_ENRICHED_SCHEMA_KEYS_SUCCEEDED =
  'GETTING_ENRICHED_SCHEMA_KEYS_SUCCEEDED';
export const GETTING_ENRICHED_SCHEMA_KEYS_FAILED =
  'GETTING_ENRICHED_SCHEMA_KEYS_FAILED';

export const CREATE_ENRICHED_SCHEMA = 'CREATE_ENRICHED_SCHEMA';
export const CREATING_ENRICHED_SCHEMA_SUCCEEDED =
  'CREATING_ENRICHED_SCHEMA_SUCCEEDED';
export const CREATING_ENRICHED_SCHEMA_FAILED =
  'CREATING_ENRICHED_SCHEMA_FAILED';

export const UPDATE_ENRICHED_SCHEMA = 'UPDATE_ENRICHED_SCHEMA';
export const UPDATING_ENRICHED_SCHEMA_SUCCEEDED =
  'UPDATING_ENRICHED_SCHEMA_SUCCEEDED';
export const UPDATING_ENRICHED_SCHEMA_FAILED =
  'UPDATING_ENRICHED_SCHEMA_FAILED';

export const SET_CURRENT_ENRICHED_SCHEMA = 'SET_CURRENT_ENRICHED_SCHEMA';
export const UNSET_CURRENT_ENRICHED_SCHEMA = 'UNSET_CURRENT_ENRICHED_SCHEMA';

export const SET_CURRENT_ENRICHED_SCHEMA_DETAILS =
  'SET_CURRENT_ENRICHED_SCHEMA_DETAILS';
export const UNSET_CURRENT_ENRICHED_SCHEMA_DETAILS =
  'UNSET_CURRENT_ENRICHED_SCHEMA_DETAILS';

export const ACTIVATE_OR_DEACTIVATE_ENRICHED_SCHEMA =
  'ACTIVATE_OR_DEACTIVATE_ENRICHED_SCHEMA';
export const ACTIVATE_OR_DEACTIVATE_ENRICHED_SCHEMA_SUCCEEDED =
  'ACTIVATE_OR_DEACTIVATE_ENRICHED_SCHEMA_SUCCEEDED';
export const ACTIVATE_OR_DEACTIVATE_ENRICHED_SCHEMA_FAILED =
  'ACTIVATE_OR_DEACTIVATE_ENRICHED_SCHEMA_FAILED';

export const LOADING_CURRENT_ENRICHED_SCHEMA =
  'LOADING_CURRENT_ENRICHED_SCHEMA';
  
export const UPDATE_ENRICHED_SCHEMA_FILTERS = 'UPDATE_ENRICHED_SCHEMA_FILTERS';
export const RESET_ENRICHED_SCHEMA_FILTERS = 'RESET_ENRICHED_SCHEMA_FILTERS';

export const getEnrichedSchemas = createAction(GET_ENRICHED_SCHEMAS);
export const getPaginatedEnrichedSchemas = createAction(GET_PAGINATED_ENRICHED_SCHEMAS);
export const gettingEnrichedSchemasSucceeded = createAction(
  GETTING_ENRICHED_SCHEMAS_SUCCEEDED
);
export const gettingPaginatedEnrichedSchemasSucceeded = createAction(
  GETTING_PAGINATED_ENRICHED_SCHEMAS_SUCCEEDED
);
export const gettingEnrichedSchemasFailed = createAction(
  GETTING_ENRICHED_SCHEMAS_FAILED
);
export const gettingPaginatedEnrichedSchemasFailed = createAction(
  GETTING_PAGINATED_ENRICHED_SCHEMAS_FAILED
);

export const getEnrichedSchema = createAction(GET_ENRICHED_SCHEMA);
export const gettingEnrichedSchemaSucceeded = createAction(
  GETTING_ENRICHED_SCHEMA_SUCCEEDED
);
export const gettingEnrichedSchemaFailed = createAction(
  GETTING_ENRICHED_SCHEMA_FAILED
);

export const getEnrichedSchemaKeys = createAction(GET_ENRICHED_SCHEMA_KEYS);
export const gettingEnrichedSchemaKeysSucceeded = createAction(
  GETTING_ENRICHED_SCHEMA_KEYS_SUCCEEDED
);
export const gettingEnrichedSchemaKeysFailed = createAction(
  GETTING_ENRICHED_SCHEMA_KEYS_FAILED
);

export const createEnrichedSchema = createAction(CREATE_ENRICHED_SCHEMA);
export const creatingEnrichedSchemaSucceeded = createAction(
  CREATING_ENRICHED_SCHEMA_SUCCEEDED
);
export const creatingEnrichedSchemaFailed = createAction(
  CREATING_ENRICHED_SCHEMA_FAILED
);

export const updateEnrichedSchema = createAction(UPDATE_ENRICHED_SCHEMA);
export const updatingEnrichedSchemaSucceeded = createAction(
  UPDATING_ENRICHED_SCHEMA_SUCCEEDED
);
export const updatingEnrichedSchemaFailed = createAction(
  UPDATING_ENRICHED_SCHEMA_FAILED
);

export const setCurrentEnrichedSchema = createAction(
  SET_CURRENT_ENRICHED_SCHEMA
);
export const unsetCurrentEnrichedSchema = createAction(
  UNSET_CURRENT_ENRICHED_SCHEMA
);

export const setCurrentEnrichedSchemaDetails = createAction(
  SET_CURRENT_ENRICHED_SCHEMA_DETAILS
);
export const unsetCurrentEnrichedSchemaDetails = createAction(
  UNSET_CURRENT_ENRICHED_SCHEMA_DETAILS
);

export const activateOrDeactivateEnrichedSchema = createAction(
  ACTIVATE_OR_DEACTIVATE_ENRICHED_SCHEMA
);
export const activateOrDeactivateEnrichedSchemaSucceeded = createAction(
  ACTIVATE_OR_DEACTIVATE_ENRICHED_SCHEMA_SUCCEEDED
);
export const activateOrDeactivateEnrichedSchemaFailed = createAction(
  ACTIVATE_OR_DEACTIVATE_ENRICHED_SCHEMA_FAILED
);

export const loadingCurrentEnrichedSchema = createAction(
  LOADING_CURRENT_ENRICHED_SCHEMA
);

export const updateEnrichedSchemaFilters = createAction(UPDATE_ENRICHED_SCHEMA_FILTERS);
export const resetEnrichedSchemaFilters = createAction(RESET_ENRICHED_SCHEMA_FILTERS);